import { render, staticRenderFns } from "./CompaniesCreateEdit.vue?vue&type=template&id=69fa76a6&scoped=true&"
import script from "./CompaniesCreateEdit.vue?vue&type=script&lang=js&"
export * from "./CompaniesCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesCreateEdit.vue?vue&type=style&index=0&id=69fa76a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fa76a6",
  null
  
)

export default component.exports